import { Injectable } from '@angular/core';
import { AppConfig, EnvironmentProfile } from '@utils/interfaces';
import { profiles } from '@utils/environment-profiles';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private value: AppConfig | undefined = undefined;

  async init(): Promise<void> {
    try {
      const response = await fetch('/assets/config/config.json');
      const data = await response.json();
      this.value = data as AppConfig;
    } catch (e) {
      throw new Error(`Fehler beim Laden der Konfigurationsdatei: ${e}`);
    }
  }

  get profile(): EnvironmentProfile {
    if (this.value !== undefined) {
      return profiles[this.value.environment];
    }
    return profiles['produktion'];
  }

  isProd(): boolean {
    return this.value ? this.value.environment === 'produktion' : false;
  }
}
